// extracted by mini-css-extract-plugin
export default {"user-feed":"UserFeedCommon_user-feed__uhAgq","user-feed__filter":"UserFeedCommon_user-feed__filter__Dc7G+","user-feed__tab-content":"UserFeedCommon_user-feed__tab-content__+NtJF"};